import styled from '@emotion/styled';

const Container = styled.div<{ isLinkMode: boolean }>`
  padding: 24px 24px 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-bottom: 1px solid var(--dk-line, #e7e9ec);
  position: fixed;
  top: ${({ isLinkMode }) => (isLinkMode ? '' : '0')};
  background-color: var(--dk-bg, white);
  z-index: 3;
  width: 100%;
`;

/**
 * 헤더 내부에 놓이는 번역 상태 띠 슬롯.
 * 음수 margin 으로 헤더 padding 을 상쇄하지 않는다 — Container 가 position:fixed + width:100%
 * 라서 좌우로 넓히면 모달에서 가로 스크롤이 생긴다. 좌우 여백은 그대로 둔다.
 */
const TranslationStatusBarSlot = styled.div<{ isModal: boolean }>`
  margin-top: -4px;
  /* 모달 우측 상단의 확대/닫기 버튼과 겹치지 않도록 — 제목 Stack 과 동일한 회피 여백 */
  margin-right: ${({ isModal }) => (isModal ? `${56 + 8}px` : 0)};
`;

const Divider = styled.div`
  width: 1px;
  height: 16px;
  background-color: var(--dk-bg-strong, #e7e9ec);
  margin: 0 12px;
`;

const Layout = styled.div<{ isScrollDown?: boolean }>`
  display: ${({ isScrollDown }) => (isScrollDown ? 'none' : 'flex')};
  align-items: center;
  justify-content: space-between;
`;

const SubHeaderLayout = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  font-size: ${({ isMobile }) => (isMobile ? '12px' : '16px')};
  align-items: ${({ isMobile }) => (isMobile ? '' : 'center')};
  white-space: nowrap;
  word-break: keep-all;
`;

const StyledCreate = styled.div`
  color: var(--dk-text-secondary, #888d96);
  line-height: 24px;
`;

const StyledTitleContainer = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid black;
`;

const StyledInput = styled.input`
  width: 100%;
  border: none;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  background-color: inherit;

  ::placeholder {
    color: var(--dk-text-dim, #b7bbc2);
  }
  :focus {
    outline: none;
  }
`;

const StyledSubject = styled.div<{
  isPlaceHolder: boolean;
  isOwner: boolean;
}>`
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
  color: ${({ isPlaceHolder }) => (isPlaceHolder ? 'var(--dk-text-dim, #B7BBC2)' : 'var(--dk-text, black)')};
  :hover {
    background-color: ${({ isOwner }) => (isOwner ? 'var(--dk-bg-subtle, #F9FAFB)' : 'var(--dk-bg, #fff)')};
  }
  :active {
    background-color: ${({ isOwner }) => (isOwner ? 'var(--dk-bg-muted, #F3F5F6)' : 'var(--dk-bg, #fff)')};
  }
  transition: background-color 0.1s ease-in-out;
  word-break: break-all;
`;

const StyledSubjectContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: var(--dk-bg-subtle, #f9fafb);
  border-bottom: 1px solid black;
`;

export {
  Container,
  TranslationStatusBarSlot,
  Divider,
  Layout,
  StyledCreate,
  StyledTitleContainer,
  StyledInput,
  StyledSubject,
  StyledSubjectContainer,
  SubHeaderLayout,
};
